

// this code will add a data-stuck attribute when the user scrolls down.  this lets us put a shadow
// on the sticky header when the sticky header is stuck to the top of the page
window.addEventListener("load", function () {
    let sticky = document.querySelector("#sticky-header")
    if (sticky === null)
        return false;

    const observer = new IntersectionObserver(
        ([e]) => e.target.toggleAttribute("data-stuck", e.intersectionRatio < 1),
        {threshold: [1]}
    );

    observer.observe(sticky);
});